// Axios client for Brand OS. Sends credentials so the bos_session cookie flows.
import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${backendUrl}/api/brand-os`,
  withCredentials: true,
  timeout: 15000,
  headers: { "Content-Type": "application/json" },
});

export function formatApiError(err) {
  if (!err) return "Something went wrong.";
  const envelope = err?.response?.data?.detail?.error || err?.response?.data?.error;
  if (envelope?.message) return envelope.message;
  // Some legacy endpoints return `{"detail": "invalid_token"}` — surface
  // the raw string so the caller sees an actionable code instead of a
  // generic axios message.
  const rawDetail = err?.response?.data?.detail;
  if (typeof rawDetail === "string" && rawDetail) return rawDetail;
  // publish-87 round-11 — structured `{reason, message}` details (e.g.
  // tiktok_sandbox_credentials_missing) read as the human message.
  if (rawDetail && typeof rawDetail === "object" && rawDetail.message) return rawDetail.message;
  if (err.message) return err.message;
  return "Something went wrong.";
}
